import { useEffect, ReactNode } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuthStatus } from '../../hooks/use-okta-only-auth'

interface ProtectedRouteProps {
  children: ReactNode
  fallback?: ReactNode
}

export function ProtectedRoute({ children, fallback }: ProtectedRouteProps) {
  const { data: isAuthenticated, isLoading } = useAuthStatus()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Store the current URI to redirect back after authentication
      const currentPath = window.location.pathname + window.location.search
      // Don't store login/callback/health pages as redirect URIs
      if (
        currentPath !== '/login' &&
        currentPath !== '/login/callback' &&
        !currentPath.startsWith('/login') &&
        !currentPath.startsWith('/health') &&
        !currentPath.startsWith('/simple-health')
      ) {
        sessionStorage.setItem('oktaRedirectUri', currentPath)
      }
      navigate({ to: '/login' })
    }
  }, [isAuthenticated, isLoading, navigate])

  if (isLoading) {
    return (
      fallback || (
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      )
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return <>{children}</>
}
